var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.NOTICE.value
    }
  }, [_c('div', {
    staticClass: "page-section-wrap"
  }, [_c('section', {
    staticClass: "page-section"
  }, [_c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("응찰 유의사항")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "9"
    }
  }, [_c('div', [_c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("낙찰 시에는 낙찰대금 외에 낙찰 수수료 (부가세 별도) 및 낙찰자 비용 (있을 경우)이 부과됩니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("모든 응찰은 응찰자가 작품을 직접 확인한 것을 전제로 합니다. 따라서, 액자나 작품 컨디션을 이유로 응찰이나 낙찰을 취소할 수 없습니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("프리뷰 기간 중 반드시 작품의 상태를 충분히 확인하신 후 경매에 응찰해 주실 것을 권장합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("모든 경매는 응찰 후에 취소가 불가능합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("특히, 온라인 라이브 응찰은 응찰하기 버튼을 누르는 동시에 즉시 시스템에 반영되어 취소가 절대 불가능하므로 유의 바랍니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("기타 응찰 시 유의사항은 경매 약관과 온라인 경매 약관을 참고 바랍니다.")])])])])])], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }